import api from '../api/axios';

const FinancialAccountService = {
  getAll: async () => {
    const response = await api.get('/FinancialAccount/get-all');
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.get(`/FinancialAccount/get-detail/${id}`);
    return response.data;
  },

  create: async (account) => {
    const response = await api.post('/FinancialAccount/create', { account });
    return response.data;
  },

  update: async (account) => {
    const response = await api.post('/FinancialAccount/update', { account });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/FinancialAccount/delete/${id}`);
    return response.data;
  }
};

export default FinancialAccountService;
